<template>
  <b-table
      :fields="fields"
      :items="items"
      table-class="text-nowrap"
      responsive
  >
    <template #cell(date)="data">
      {{ convertFromUtc(data.item.date, 'MM/DD/YYYY HH:mm A') }}
    </template>
    <template #cell(company)="data">
      <h4 class="mb-0">
        <b-link :to="{name: 'admin-company', params: {id: data.item.company.id}}">
          {{ data.item.company.name }}
        </b-link>
      </h4>
    </template>
    <template #cell(type)="data">
      <template v-if="data.item.type === 'order_fee'">Order Fee Payment</template>
      <template v-else-if="data.item.type === 'pricing_plan'">Pricing Plan Payment</template>
      <template v-else>{{ data.item.type }}</template>
    </template>
    <template #cell(amount)="data">
      {{ getFormattedPrice(data.item.total_payment) }}
      <div v-if="data.item.total_refunded" class="text-danger">
        Refunded: {{ getFormattedPrice(data.item.total_refunded) }}
      </div>
    </template>
    <template #cell(transaction)="data">
      <div v-if="data.item.transaction_id">ID: {{ data.item.transaction_id }}</div>
      <div v-if="data.item.auth_code">Auth Code: {{ data.item.auth_code }}</div>
      <div v-if="data.item.response_code">Response Code: {{ data.item.response_code }}</div>
      <div v-if="data.item.transaction_status">
        Status: <span :class="{'text-danger': data.item.transaction_status === 'failed'}">{{ data.item.transaction_status }}</span>
      </div>
    </template>
    <template #cell(payment_method)="data">
      <template v-if="data.item.payment_method === 'auth_net'">Authorize.Net</template>
      <template v-else>{{ data.item.payment_method }}</template>
      <div v-if="data.item.card_brand">
        {{ data.item.card_brand }} card ending in {{ data.item.card_ending }}
      </div>
      <div v-if="data.item.account_type">
        {{ data.item.account_type }} account ending in {{ data.item.account_ending }}
      </div>
      <div v-if="data.item.routing_number">
        Routing number: {{ data.item.routing_number }}
      </div>
      <div v-if="data.item.error" class="text-danger">{{ data.item.error }}</div>
    </template>
    <template #cell(orders)="data">
      <span v-for="(orderId, key) in data.item.orders" :key="key" class="mr-2">
        <b-link :to="{name: 'admin-order', params: {id: orderId}}">
          {{ orderId }}
        </b-link>
      </span>
    </template>
    <template #cell(pricing_plans)="data">
      <span v-for="(pPlan, key) in data.item.pricing_plans" :key="key" class="mr-2">
        <b-link :to="{name: 'admin-pricing-plan-view', params: {id: pPlan.id}}">
          {{ pPlan.name }}
        </b-link>
      </span>
    </template>
  </b-table>
</template>

<script>
import {convertFromUtc, getFormattedPrice} from "../helpers";

export default {
  name: "AdminChargesTable",
  methods: {getFormattedPrice, convertFromUtc},
  props: {
    charges: Array
  },
  data() {
    return {
      fields: [
        {
          key: "date",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "company",
          thClass: "border-top-0 admin-billing-company-col",
          tdClass: "align-middle admin-billing-company-col"
        },
        {
          key: "type",
          thClass: "border-top-0 admin-billing-payment-type-col",
          tdClass: "align-middle admin-billing-payment-type-col"
        },
        {
          key: "amount",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "transaction",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "payment_method",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "orders",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "pricing_plans",
          thClass: "border-top-0 admin-billing-plan-col",
          tdClass: "align-middle admin-billing-plan-col"
        },
      ]
    }
  },
  computed: {
    items() {
      return this.charges;
    }
  }
}
</script>
